import "./dap.0513b293.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire10c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire10c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("e5CeE", function(module, exports) {

$parcel$export(module.exports, "ToastComponent", () => $21471cd9440ef0a2$export$8743ba3ef25f9582);

var $e7kxL = parcelRequire("e7kxL");

var $g6LfW = parcelRequire("g6LfW");
class $21471cd9440ef0a2$export$8743ba3ef25f9582 extends HTMLElement {
    _message = null;
    props;
    propNames = {
        dataShow: "data-show",
        dataHide: "data-hide"
    };
    template = ()=>`
   <style>${$g6LfW}</style>
   <div class="toast-container">
   <div class="toast" ></div>
   </div>`;
    static get observedAttributes() {
        return [
            "data-show"
        ];
    }
    constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
        this.props = (0, $e7kxL.getAllProps)(this);
        this.render();
    }
    get message() {
        return this._message;
    }
    set message(value) {
        this._message = value;
    }
    initializeToastMessage() {
        const element = this.shadowRoot?.querySelector(".toast");
        console.log(this.message);
        if (this.message && this.message.type && this.message.text) {
            element?.classList.add(this.message.type);
            element.textContent = this.message.text;
        } else console.log("failed to initialize toast message ", this.message);
    }
    connectedCallback() {
        this.initializeToastMessage();
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === this.propNames.dataShow) {
            const element = this.shadowRoot?.querySelector(".toast");
            element?.classList.add("show");
        }
        if (name === this.propNames.dataHide) {
            const element = this.shadowRoot?.querySelector(".toast");
            element?.classList.remove("show");
        }
    }
    render() {
        if (this.shadowRoot) this.shadowRoot.innerHTML = this.template().trim();
    }
}
customElements.define("toast-component", $21471cd9440ef0a2$export$8743ba3ef25f9582);

});
parcelRegister("g6LfW", function(module, exports) {
module.exports = "@keyframes blur{0%{filter:blur(10px);transform:translate(-15vw)}to{filter:blur();transform:translate(0)}}@keyframes space{0%{letter-spacing:0}50%{letter-spacing:6px}to{letter-spacing:unset}}@keyframes from-left{0%{opacity:.4;transform:translate(-2vw)translateZ(2vw)}to{transform:unset;opacity:.7}}@keyframes click{0%{transform:scale(1.2)}to{transform:scale(1)}}:host .toast-container{text-align:center;z-index:1000;border-radius:12px;width:300px;position:fixed;bottom:20%;left:50%;transform:translate(-50%,-10%)}:host .toast-container .toast{color:#fff;opacity:0;background-color:#333;border-radius:4px;margin-bottom:10px;padding:16px;transition:opacity .5s ease-in-out}:host .toast-container>.toast.success{background-color:#4caf50}:host .toast-container>.toast.error{background-color:#f44336}:host .toast-container>.toast.show{opacity:1}@media (width<=450px){:host .toast-container{text-align:center;z-index:1000;border-radius:12px;width:300px;position:fixed;top:10%;left:50%;transform:translate(-50%,-10%)}}";

});



var $ezJWQ = parcelRequire("ezJWQ");

var $e5CeE = parcelRequire("e5CeE");
var $784ba71ef5c887fe$exports = {};
$784ba71ef5c887fe$exports = "@keyframes blur{0%{filter:blur(10px);transform:translate(-15vw)}to{filter:blur();transform:translate(0)}}@keyframes space{0%{letter-spacing:0}50%{letter-spacing:6px}to{letter-spacing:unset}}@keyframes from-left{0%{opacity:.4;transform:translate(-2vw)translateZ(2vw)}to{transform:unset;opacity:.7}}@keyframes click{0%{transform:scale(1.2)}to{transform:scale(1)}}:host{background:linear-gradient(#fff 0%,#ffc0cbde 100%);flex-direction:column;justify-content:flex-start;align-items:center;width:98vw;height:194vh;display:flex}:host .header{color:#000c;text-align:center;background-color:#ffffff80;flex-direction:column;justify-content:center;align-items:center;width:98vw;height:14vh;display:flex}:host .header_title{font-family:Poppins,sans-serif;font-size:2.4vw;font-style:normal;font-weight:600}:host .header_brief{font-family:Poppins,sans-serif;font-size:1vw;font-style:normal;font-weight:500}:host .company{width:98vw;height:90vh;position:relative}:host .company_name{text-align:center;color:#fffc;z-index:2;align-content:center;height:8vh;font-family:Poppins,sans-serif;font-size:1.8vw;font-style:normal;font-weight:700;position:absolute;top:0;left:0;right:0}:host .company_img{z-index:0;width:inherit;height:inherit;position:relative}:host .company_img .desc{backdrop-filter:blur(4px);color:#fffc;z-index:1;background-color:#00000080;border-top-right-radius:8px;width:40%;font-family:Poppins,sans-serif;font-size:1.8vw;font-style:normal;font-weight:500;position:absolute;top:8vh;bottom:0;left:0}:host .company_img .desc h3{margin:0;padding:0 8px}:host .company_img .desc ul{margin-bottom:0}:host .company_img .desc ul li{padding-top:12px}:host .valtech{background:url(bmg_lg.df53adc2.jpg) 50%/cover no-repeat}:host .creshya{background:url(hopon_lg.25cd0cd7.jpg) 50%/cover no-repeat}.animation_space{animation:1s space}.animation_blur{animation:2s blur}@media (width<=450px){:host{gap:2vh;width:98vw;height:100vh}:host .header{width:98vw;height:10vh}:host .header_title{font-size:4.8vw}:host .header_brief{font-size:3.6vw}:host .company{width:94vw;height:42vh;position:unset;background-color:#fa64d980;border-radius:8px;flex-direction:column;justify-content:center;align-items:center;display:flex}:host .company_name{position:unset;width:\"inherit\";color:#000c;height:6vh;font-size:3.6vw}:host .company_img{border-radius:8px;width:84vw;height:32vh}:host .company_img .desc{width:50%;font-size:3.6vw;top:0}:host .company_img .desc ul{margin-bottom:0}:host .company_img .desc ul li{padding-top:4px}:host .valtech{background:url(bmg_sm.6d378e74.jpg) 50%/cover no-repeat}:host .creshya{background:url(hopon_sm.c6b311b1.jpg) 50%/cover no-repeat}}@media (width>=451px) and (width<=992px) and (orientation:portrait){:host{width:98vw;height:114vh}:host .header_title{font-size:3.6vw}:host .header_brief{font-size:2vw}:host .company{width:98vw;height:50vh}:host .company_name{font-size:3.6vw}:host .company_img .desc{font-size:2vw}}";


var $28e81185758a6e03$exports = {};
$28e81185758a6e03$exports = "<div class=header>\n  <div class=header_title>Featured Projects</div>\n  <div class=header_brief>Showcasing some of my recent work</div>\n</div>\n<div class=company>\n  <div class=\"company_name one\">Valtech</div>\n  <div class=\"company_img valtech\">\n    <div class=\"desc vdesc\">\n      <h3>BMG Music</h3>\n      <ul>\n        <li>UI Design &amp; Development</li>\n        <li>Backend API</li>\n        <li>Database</li>\n        <li>Cache</li>\n        <li>Reports &amp; Billing</li>\n        <li>Duration:2020-24</li>\n      </ul>\n    </div>\n  </div>\n</div>\n<div class=company>\n  <div class=\"company_name two\">Creshya Technologies</div>\n  <div class=\"company_img creshya\">\n    <div class=\"cdesc desc\">\n      <h3>Hopon Cabs</h3>\n      <ul>\n        <li>UI Design &amp; Development</li>\n        <li>Backend API</li>\n        <li>Database</li>\n        <li>Cache</li>\n        <li>Reports &amp; Billing</li>\n        <li>Duration:2018-20</li>\n      </ul>\n    </div>\n  </div>\n</div>\n";



var $e7kxL = parcelRequire("e7kxL");
class $47ce20f770578c92$export$2c92791fa4a99cea extends HTMLElement {
    ComponentElements;
    ComponentNames = {
        valtech: ".one",
        creshya: ".two",
        vdesc: ".vdesc",
        cdesc: ".cdesc"
    };
    template = ()=>`
   <style>${$784ba71ef5c887fe$exports}</style>
   ${0, (/*@__PURE__*/$parcel$interopDefault($28e81185758a6e03$exports))}
  `;
    constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
        this.render();
        this.ComponentElements = (0, $e7kxL.getRequiredComponentElements)(this, this.ComponentNames);
        this.initializeAnimationObservers();
    }
    initializeAnimationObservers() {
        [
            this.ComponentNames.valtech,
            this.ComponentNames.creshya
        ].forEach((item)=>{
            const el = this.ComponentElements.get(item);
            if (!el) return;
            const observer = new IntersectionObserver(([entry])=>{
                if (entry.isIntersecting) {
                    el.classList.remove("animation_space"); // Reset in case
                    // Force reflow to restart animation
                    el.offsetWidth;
                    el.classList.add("animation_space");
                } else el.classList.remove("animation_space");
            }, {
                threshold: 0.1
            });
            observer.observe(el);
        });
        [
            this.ComponentNames.vdesc,
            this.ComponentNames.cdesc
        ].forEach((item)=>{
            const el = this.ComponentElements.get(item);
            if (!el) return;
            const observer = new IntersectionObserver(([entry])=>{
                if (entry.isIntersecting) {
                    el.classList.remove("animation_blur"); // Reset in case
                    // Force reflow to restart animation
                    el.offsetWidth;
                    el.classList.add("animation_blur");
                } else el.classList.remove("animation_blur");
            }, {
                threshold: 0.1
            });
            observer.observe(el);
        });
    }
    connectedCallback() {}
    render() {
        if (this.shadowRoot) this.shadowRoot.innerHTML = this.template().trim();
    }
}
customElements.define("company-component", $47ce20f770578c92$export$2c92791fa4a99cea);



var $e7kxL = parcelRequire("e7kxL");
var $1fc0fccae746bdfa$exports = {};
$1fc0fccae746bdfa$exports = "@keyframes blur{0%{filter:blur(10px);transform:translate(-15vw)}to{filter:blur();transform:translate(0)}}@keyframes space{0%{letter-spacing:0}50%{letter-spacing:6px}to{letter-spacing:unset}}@keyframes from-left{0%{opacity:.4;transform:translate(-2vw)translateZ(2vw)}to{transform:unset;opacity:.7}}@keyframes click{0%{transform:scale(1.2)}to{transform:scale(1)}}:host{background-color:#2e0b79;flex-direction:column;justify-content:flex-start;align-items:center;width:98vw;height:98vh;display:flex}:host .header{color:#fffc;text-align:center;flex-direction:column;justify-content:center;align-items:center;width:98vw;height:14vh;display:flex}:host .header_title{font-family:Poppins,sans-serif;font-size:2.4vw;font-style:normal;font-weight:600}:host .header_brief{font-family:Poppins,sans-serif;font-size:1vw;font-style:normal;font-weight:500}:host .contact{letter-spacing:1px;background-color:#ffffff1a;border-radius:8px;flex-direction:column;justify-content:center;align-items:center;width:40vw;height:74vh;font-family:Poppins,sans-serif;font-style:normal;font-weight:400;display:flex}:host .contact .form-group{flex-direction:column;place-content:center;align-items:flex-start;width:34vw;height:max-content;display:flex}:host .contact .form-group>.success{width:inherit;text-align:center;color:#0bda51;display:none}:host .contact .form-group>.error{width:inherit;text-align:center;color:#f40009;display:none}:host .contact .form-group label,:host .contact .form-group input,:host .contact .form-group textarea,:host .contact .form-group button{height:4vh;width:inherit;color:#fffc;margin-top:1vh;display:block}:host .contact .form-group label{color:#ffffff80;pointer-events:none;width:fit-content;height:3.5vh;font-family:Poppins,sans-serif;font-size:1vw;font-style:normal;font-weight:600;transform:translateY(-4vh)translate(1vw)}:host .contact .form-group label>span{color:#0bda51;display:none}:host .contact .form-group input,:host .contact .form-group textarea,:host .contact .form-group button{background-color:#0000;border:1px solid #fff3;border-radius:8px;outline-style:none}:host .contact .form-group input::placeholder{color:#0000}:host .contact .form-group input:user-valid~label>span{display:inline-block}:host .contact .form-group input:user-invalid~label{transform:translateY(-8vh)translate(0)}:host .contact .form-group input:user-invalid~label:after{content:\"  enter valid input\";color:#d85424;width:100px}:host .contact .form-group input:-webkit-autofill{-webkit-text-fill-color:#fffc;border:1px solid #fff3;transition:background-color 5000s ease-in-out;-webkit-box-shadow:inset 0 0 0 1000px #0000}:host .contact .form-group input:-webkit-autofill:hover{-webkit-text-fill-color:#fffc;border:1px solid #fff3;transition:background-color 5000s ease-in-out;-webkit-box-shadow:inset 0 0 0 1000px #0000}:host .contact .form-group input:-webkit-autofill:focus{-webkit-text-fill-color:#fffc;border:1px solid #fff3;transition:background-color 5000s ease-in-out;-webkit-box-shadow:inset 0 0 0 1000px #0000}:host .contact .form-group input:is(:focus,:not(:placeholder-shown)){border:1px solid #ffffffe6}:host .contact .form-group input:is(:focus,:not(:placeholder-shown))~label{color:#fffc;transition:all .2s;transform:translateY(-8.4vh)translate(0)}:host .contact .form-group textarea{resize:none;height:18vh}:host .contact .form-group button{cursor:pointer;background:linear-gradient(134.05deg,#b51111 1.64%,#350769 98.36%);margin-top:24px}@media (width<=450px){:host{width:98vw;height:98vh}:host .header{color:#fffc;text-align:center;flex-direction:column;justify-content:center;align-items:center;width:98vw;height:10vh;display:flex}:host .header_title{font-size:4.8vw}:host .header_brief{font-size:3vw}:host .contact{width:86vw;height:74vh;margin-top:2vh}:host .contact .form-group{width:74vw;height:max-content}:host .contact .form-group label{font-size:3vw;transform:translateY(-4vh)translate(4vw)}}.disable{mix-blend-mode:soft-light;pointer-events:none}@media (width>=451px) and (width<=992px) and (orientation:portrait){:host .header{color:#fffc;text-align:center;flex-direction:column;justify-content:center;align-items:center;width:98vw;height:10vh;display:flex}:host .header_title{font-size:4.8vw}:host .header_brief{font-size:2vw}:host .contact{width:74vw;height:74vh;margin-top:2vh}:host .contact .form-group{width:64vw;height:max-content}:host .contact .form-group label{font-size:2vw;transform:translateY(-4vh)translate(2vw)}}";


var $6e93226ed8316406$exports = {};
$6e93226ed8316406$exports = "<div class=header>\n  <div class=header_title>Get in Touch</div>\n  <div class=header_brief>\n    Have a project in mind.Let's discuss how i can help u.\n  </div>\n</div>\n<form class=contact id=feedbackForm>\n  <div class=form-group>\n    <input name=name placeholder=Name minlength=3 value required>\n    <label for=name>Name&nbsp; <span>✔</span></label>\n  </div>\n\n  <div class=form-group>\n    <input type=email name=email placeholder=Email minlength=10 value required>\n    <label for=email>Email&nbsp; <span>✔</span></label>\n  </div>\n  <div class=form-group>\n    <input name=subject placeholder=Subject minlength=4 value required>\n    <label for=subject>Subject&nbsp; <span>✔</span></label>\n  </div>\n  <div class=form-group>\n    <textarea name=message placeholder=\"Your message\" minlength=10 value required></textarea>\n  </div>\n  <div class=form-group>\n    <button>Send Message</button>\n  </div>\n  <div class=form-group>\n    <p class=success>\n      Dear customer,We have received you feedback.Thank you.\n    </p>\n    <p class=error>\n      There was an error in sending your feedback. Please try again later.\n    </p>\n  </div>\n</form>\n";


class $365480cad2bbacec$export$29b488039e3d4c2d {
    constructor(_status = 0, _text = 'Network Error'){
        this.status = _status;
        this.text = _text;
    }
}


const $050ad26521b99438$export$2b84f07db8df86ee = ()=>{
    if (typeof localStorage === 'undefined') return;
    return {
        get: (key)=>Promise.resolve(localStorage.getItem(key)),
        set: (key, value)=>Promise.resolve(localStorage.setItem(key, value)),
        remove: (key)=>Promise.resolve(localStorage.removeItem(key))
    };
};


const $c798475fc5eb7ae4$export$6f57813fe9f31bf9 = {
    origin: 'https://api.emailjs.com',
    blockHeadless: false,
    storageProvider: (0, $050ad26521b99438$export$2b84f07db8df86ee)()
};


const $0b89b563b8ce5c16$export$ecbd7d678ac4909b = (options)=>{
    if (!options) return {};
    // support compatibility with SDK v3
    if (typeof options === 'string') return {
        publicKey: options
    };
    // eslint-disable-next-line @typescript-eslint/no-base-to-string
    if (options.toString() === '[object Object]') return options;
    return {};
};


const $521ca2b4a362b637$export$2cd8252107eb640b = (options, origin = 'https://api.emailjs.com')=>{
    if (!options) return;
    const opts = (0, $0b89b563b8ce5c16$export$ecbd7d678ac4909b)(options);
    (0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).publicKey = opts.publicKey;
    (0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).blockHeadless = opts.blockHeadless;
    (0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).storageProvider = opts.storageProvider;
    (0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).blockList = opts.blockList;
    (0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).limitRate = opts.limitRate;
    (0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).origin = opts.origin || origin;
};





const $ec190f1f3b1ae57b$export$4a68059d3a005c64 = async (url, data, headers = {})=>{
    const response = await fetch((0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).origin + url, {
        method: 'POST',
        headers: headers,
        body: data
    });
    const message = await response.text();
    const responseStatus = new (0, $365480cad2bbacec$export$29b488039e3d4c2d)(response.status, message);
    if (response.ok) return responseStatus;
    throw responseStatus;
};



const $90a7819081cf59b4$export$1f3bf48e9edf7d72 = (publicKey, serviceID, templateID)=>{
    if (!publicKey || typeof publicKey !== 'string') throw 'The public key is required. Visit https://dashboard.emailjs.com/admin/account';
    if (!serviceID || typeof serviceID !== 'string') throw 'The service ID is required. Visit https://dashboard.emailjs.com/admin';
    if (!templateID || typeof templateID !== 'string') throw 'The template ID is required. Visit https://dashboard.emailjs.com/admin/templates';
};


const $606788fef0a93b78$export$80b670b04253020b = (templateParams)=>{
    // eslint-disable-next-line @typescript-eslint/no-base-to-string
    if (templateParams && templateParams.toString() !== '[object Object]') throw 'The template params have to be the object. Visit https://www.emailjs.com/docs/sdk/send/';
};


const $9e97281bc02a549f$export$b509da924d51a9a9 = (navigator)=>{
    return navigator.webdriver || !navigator.languages || navigator.languages.length === 0;
};



const $ab7d2fa3f7df0c38$export$a8135c843594e85b = ()=>{
    return new (0, $365480cad2bbacec$export$29b488039e3d4c2d)(451, 'Unavailable For Headless Browser');
};


const $d4556afef3d17824$export$1727dd877829fee8 = (list, watchVariable)=>{
    if (!Array.isArray(list)) throw 'The BlockList list has to be an array';
    if (typeof watchVariable !== 'string') throw 'The BlockList watchVariable has to be a string';
};


const $52e7c6c8b64bb1c0$var$isBlockListDisabled = (options)=>{
    return !options.list?.length || !options.watchVariable;
};
const $52e7c6c8b64bb1c0$var$getValue = (data, name)=>{
    return data instanceof FormData ? data.get(name) : data[name];
};
const $52e7c6c8b64bb1c0$export$c7ab883573eb12a4 = (options, params)=>{
    if ($52e7c6c8b64bb1c0$var$isBlockListDisabled(options)) return false;
    (0, $d4556afef3d17824$export$1727dd877829fee8)(options.list, options.watchVariable);
    const value = $52e7c6c8b64bb1c0$var$getValue(params, options.watchVariable);
    if (typeof value !== 'string') return false;
    return options.list.includes(value);
};



const $e033b5517693ceb4$export$b30160cec00781e = ()=>{
    return new (0, $365480cad2bbacec$export$29b488039e3d4c2d)(403, 'Forbidden');
};


const $f1b4a42f5460eb37$export$88c64f8d5fea404b = (throttle, id)=>{
    if (typeof throttle !== 'number' || throttle < 0) throw 'The LimitRate throttle has to be a positive number';
    if (id && typeof id !== 'string') throw 'The LimitRate ID has to be a non-empty string';
};


const $ccb9264e82a8b92f$var$getLeftTime = async (id, throttle, storage)=>{
    const lastTime = Number(await storage.get(id) || 0);
    return throttle - Date.now() + lastTime;
};
const $ccb9264e82a8b92f$export$8b7f6a1a004faa27 = async (defaultID, options, storage)=>{
    if (!options.throttle || !storage) return false;
    (0, $f1b4a42f5460eb37$export$88c64f8d5fea404b)(options.throttle, options.id);
    const id = options.id || defaultID;
    const leftTime = await $ccb9264e82a8b92f$var$getLeftTime(id, options.throttle, storage);
    if (leftTime > 0) return true;
    await storage.set(id, Date.now().toString());
    return false;
};



const $0c0740911a700545$export$29b72785a20a20d9 = ()=>{
    return new (0, $365480cad2bbacec$export$29b488039e3d4c2d)(429, 'Too Many Requests');
};


const $4e1a944052b5621b$export$89db4734f6c919c4 = async (serviceID, templateID, templateParams, options)=>{
    const opts = (0, $0b89b563b8ce5c16$export$ecbd7d678ac4909b)(options);
    const publicKey = opts.publicKey || (0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).publicKey;
    const blockHeadless = opts.blockHeadless || (0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).blockHeadless;
    const storageProvider = opts.storageProvider || (0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).storageProvider;
    const blockList = {
        ...(0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).blockList,
        ...opts.blockList
    };
    const limitRate = {
        ...(0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).limitRate,
        ...opts.limitRate
    };
    if (blockHeadless && (0, $9e97281bc02a549f$export$b509da924d51a9a9)(navigator)) return Promise.reject((0, $ab7d2fa3f7df0c38$export$a8135c843594e85b)());
    (0, $90a7819081cf59b4$export$1f3bf48e9edf7d72)(publicKey, serviceID, templateID);
    (0, $606788fef0a93b78$export$80b670b04253020b)(templateParams);
    if (templateParams && (0, $52e7c6c8b64bb1c0$export$c7ab883573eb12a4)(blockList, templateParams)) return Promise.reject((0, $e033b5517693ceb4$export$b30160cec00781e)());
    if (await (0, $ccb9264e82a8b92f$export$8b7f6a1a004faa27)(location.pathname, limitRate, storageProvider)) return Promise.reject((0, $0c0740911a700545$export$29b72785a20a20d9)());
    const params = {
        lib_version: '4.4.1',
        user_id: publicKey,
        service_id: serviceID,
        template_id: templateID,
        template_params: templateParams
    };
    return (0, $ec190f1f3b1ae57b$export$4a68059d3a005c64)('/api/v1.0/email/send', JSON.stringify(params), {
        'Content-type': 'application/json'
    });
};





const $fb360b4e9f3d39cc$export$ed692cabb252e59b = (form)=>{
    if (!form || form.nodeName !== 'FORM') throw 'The 3rd parameter is expected to be the HTML form element or the style selector of the form';
};









const $4a4df2b20f870b5d$var$findHTMLForm = (form)=>{
    return typeof form === 'string' ? document.querySelector(form) : form;
};
const $4a4df2b20f870b5d$export$c13a0f9407ffb567 = async (serviceID, templateID, form, options)=>{
    const opts = (0, $0b89b563b8ce5c16$export$ecbd7d678ac4909b)(options);
    const publicKey = opts.publicKey || (0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).publicKey;
    const blockHeadless = opts.blockHeadless || (0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).blockHeadless;
    const storageProvider = (0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).storageProvider || opts.storageProvider;
    const blockList = {
        ...(0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).blockList,
        ...opts.blockList
    };
    const limitRate = {
        ...(0, $c798475fc5eb7ae4$export$6f57813fe9f31bf9).limitRate,
        ...opts.limitRate
    };
    if (blockHeadless && (0, $9e97281bc02a549f$export$b509da924d51a9a9)(navigator)) return Promise.reject((0, $ab7d2fa3f7df0c38$export$a8135c843594e85b)());
    const currentForm = $4a4df2b20f870b5d$var$findHTMLForm(form);
    (0, $90a7819081cf59b4$export$1f3bf48e9edf7d72)(publicKey, serviceID, templateID);
    (0, $fb360b4e9f3d39cc$export$ed692cabb252e59b)(currentForm);
    const formData = new FormData(currentForm);
    if ((0, $52e7c6c8b64bb1c0$export$c7ab883573eb12a4)(blockList, formData)) return Promise.reject((0, $e033b5517693ceb4$export$b30160cec00781e)());
    if (await (0, $ccb9264e82a8b92f$export$8b7f6a1a004faa27)(location.pathname, limitRate, storageProvider)) return Promise.reject((0, $0c0740911a700545$export$29b72785a20a20d9)());
    formData.append('lib_version', '4.4.1');
    formData.append('service_id', serviceID);
    formData.append('template_id', templateID);
    formData.append('user_id', publicKey);
    return (0, $ec190f1f3b1ae57b$export$4a68059d3a005c64)('/api/v1.0/email/send-form', formData);
};


var $e8e08de5e84870c6$export$2e2bcd8739ae039 = {
    init: $521ca2b4a362b637$export$2cd8252107eb640b,
    send: $4e1a944052b5621b$export$89db4734f6c919c4,
    sendForm: $4a4df2b20f870b5d$export$c13a0f9407ffb567,
    EmailJSResponseStatus: $365480cad2bbacec$export$29b488039e3d4c2d
};


async function $a8d91612302eee62$export$740088ca56a0225c(attrs = {}) {
    const Id = "service_skggd0m";
    const templateId = "template_69h4flc";
    const Subject = "bluetweak request: " + attrs.subject;
    const Params = {
        name: attrs.name,
        email: attrs.email,
        message: attrs.message,
        subject: Subject
    };
    try {
        await (0, $e8e08de5e84870c6$export$2e2bcd8739ae039).send(Id, templateId, Params, {
            publicKey: "rZkAUEdR6DvR_D726"
        });
        return true;
    } catch (error) {
        console.log("FAILED...", error);
        return false;
    }
}


class $bcb56616bf6c4d42$export$f5d4b1ce866dd389 extends HTMLElement {
    props;
    propNames = {};
    ComponentElements;
    ComponentNames = {
        form: "#feedbackForm",
        success: ".success",
        error: ".error",
        name: `input[name='name']`,
        email: `input[name='email']`,
        subject: `input[name='subject']`,
        message: `textarea[name='message']`,
        button: "button"
    };
    template = ()=>`
   <style>${$1fc0fccae746bdfa$exports}</style>
   ${0, (/*@__PURE__*/$parcel$interopDefault($6e93226ed8316406$exports))}
  `;
    constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
        this.props = (0, $e7kxL.getAllProps)(this);
        this.render();
        this.ComponentElements = (0, $e7kxL.getRequiredComponentElements)(this, this.ComponentNames);
    }
    connectedCallback() {
        const formElement = this.ComponentElements.get(this.ComponentNames.form);
        if (formElement) formElement.addEventListener("submit", this);
    }
    disableSubmitButton() {
        const button = this.ComponentElements.get(this.ComponentNames.button);
        if (button) button.classList.add("disable");
    }
    enableSubmitButton() {
        const button = this.ComponentElements.get(this.ComponentNames.button);
        if (button) button.classList.remove("disable");
    }
    handleEvent(ev) {
        ev.preventDefault();
        this.disableSubmitButton();
        const nameEle = this.ComponentElements.get(this.ComponentNames.name);
        const emailEle = this.ComponentElements.get(this.ComponentNames.email);
        const subjectEle = this.ComponentElements.get(this.ComponentNames.subject);
        const messageEle = this.ComponentElements.get(this.ComponentNames.message);
        const attrs = {
            name: nameEle.value || "NA",
            email: emailEle.value || "NA",
            message: messageEle.value || "NA",
            subject: subjectEle.value || "NA"
        };
        this.sendMail(attrs);
        this.enableSubmitButton();
    }
    resetFrom() {
        const form = this.ComponentElements.get(this.ComponentNames.form);
        form.reset();
    }
    async sendMail(attrs = {}) {
        const mailStatus = await (0, $a8d91612302eee62$export$740088ca56a0225c)(attrs);
        if (mailStatus) {
            const success = this.ComponentElements.get(this.ComponentNames.success);
            success.style.display = "block";
            setTimeout(()=>{
                success.style.transition = "all 400ms ease";
                success.style.display = "none";
                this.resetFrom();
            }, 2000);
        } else {
            const error = this.ComponentElements.get(this.ComponentNames.error);
            error.style.display = "block";
            setTimeout(()=>{
                error.style.transition = "all 400ms ease";
                error.style.display = "none";
                this.resetFrom();
            }, 2000);
        }
    }
    disconnectedCallback() {
        const formElement = this.ComponentElements.get(this.ComponentNames.form);
        if (formElement) formElement.removeEventListener("submit", this);
    }
    render() {
        if (this.shadowRoot) this.shadowRoot.innerHTML = this.template().trim();
    }
}
customElements.define("contact-component", $bcb56616bf6c4d42$export$f5d4b1ce866dd389);


var $0f924eceae744768$exports = {};
$0f924eceae744768$exports = "@keyframes blur{0%{filter:blur(10px);transform:translate(-15vw)}to{filter:blur();transform:translate(0)}}@keyframes space{0%{letter-spacing:0}50%{letter-spacing:6px}to{letter-spacing:unset}}@keyframes from-left{0%{opacity:.4;transform:translate(-2vw)translateZ(2vw)}to{transform:unset;opacity:.7}}@keyframes click{0%{transform:scale(1.2)}to{transform:scale(1)}}:host{background-color:#0000;background-image:linear-gradient(#6f96f6e6 0%,#4b6ec4e6 100%),url(home.217d9290.jpg);background-position:0 0,50%;background-repeat:repeat,no-repeat;background-size:cover;background-attachment:scroll,scroll;background-origin:padding-box,padding-box;background-clip:border-box,border-box;justify-content:center;align-items:center;width:98vw;height:98vh;display:flex;overflow:hidden}:host .ellipse{filter:blur(100px);z-index:0;border-radius:50%;width:400px;height:400px;position:absolute}:host .ellipse.one{background-color:#ffffff80;left:10vw}:host .ellipse.two{background-color:#17cdffb3;right:10vw}:host .background{z-index:1;background-color:#0000001a;position:absolute;inset:0 0 1vw}:host .hero{backdrop-filter:blur(6px);z-index:2;flex-direction:column;justify-content:center;align-items:center;gap:60px;width:56vw;height:80vh;display:flex}:host .hero>.text{width:inherit;flex-direction:column;justify-content:center;align-items:center;display:flex}:host .hero>.text>.header{text-align:center}:host .hero>.text>.header>.name{color:#00000080;font-family:Poppins,sans-serif;font-size:2.4vw;font-style:normal;font-weight:600}:host .hero>.text>.header>.designation{-webkit-text-fill-color:transparent;background:linear-gradient(45deg,#fff 0%,#83eeeed9 36%,#f8b5f9d9 52%,#e6bc2fd9 86%) text;padding:0 2vw;font-family:Poppins,sans-serif;font-size:3.8vw;font-style:normal;font-weight:700}:host .hero>.text>.description{letter-spacing:2px;color:#fffc;text-align:center;margin-top:16px;padding:0 12px;font-family:Poppins,sans-serif;font-size:1.8vw;font-style:normal;font-weight:600}:host .hero>.cta{justify-content:center;align-items:center;gap:8vw;padding-left:24px;display:flex}:host .hero>.cta>.btn{color:#fffc;text-align:center;cursor:pointer;background-color:#58d1da80;border:1px solid #58d1dacc;border-radius:20px;align-content:center;width:8vw;height:4vh;padding:4px 12px;font-family:Poppins,sans-serif;font-size:1vw;font-style:normal;font-weight:600;box-shadow:0 4px 4px #38383859}:host .hero>.cta>.btn:last-child{background-color:#fa64d980;border:1px solid #fa64d9cc}:host .illustration{z-index:2;mix-blend-mode:overlay;background:url(homeIllustration.faba3d5f.png) 50%/contain no-repeat;width:44vw;height:60vh}@media (width<=450px){:host{background:linear-gradient(#6f96f6e6 0%,#4b6ec4e6 100%),url(home_sm.ac46ea48.jpg) 50% no-repeat;place-items:center;display:grid;position:relative}:host .ellipse{filter:blur(90px);width:250px;height:260px;position:absolute}:host .ellipse.one{background-color:#fffc;top:2vw;left:20vw}:host .ellipse.two{bottom:10vw;left:10vw}:host .hero{background:#0000002e;border-radius:40px 150px 0;gap:40px;width:90vw;height:94vw;margin-top:2vh;box-shadow:0 6px 12px #f1f0f040}:host .hero>.text{width:82vw}:host .hero>.text>.header>.name{font-size:4.8vw}:host .hero>.text>.header>.designation{font-size:7.4vw}:host .hero>.text>.description{font-size:3.6vw}:host .hero>.cta{gap:24px}:host .hero>.cta>.btn{width:16vw;height:2.6vh;font-size:3vw}:host .illustration{background:url(homeIllustration_sm.2fbe9694.png) 50% no-repeat;width:74vw;height:35vh}}@media (width>=451px) and (width<=992px) and (orientation:portrait){:host{place-items:center;display:grid;position:relative}:host .hero{gap:40px;width:80vw;height:74vw;margin-top:2vh}:host .hero>.text{width:82vw}:host .hero>.text>.header>.name{font-size:4.8vw}:host .hero>.text>.header>.designation{font-size:7.4vw}:host .hero>.text>.description{font-size:3.6vw}:host .hero>.cta{gap:10vw}:host .hero>.cta>.btn{width:16vw;height:4vh;font-size:2vw}:host .illustration{width:74vw;height:40vh}:host .ellipse.one{top:0;left:15vw}:host .ellipse.two{bottom:5vw;left:25vw}:host .background{background-color:#0000002e}}@media (width>=451px) and (width<=992px) and (orientation:landscape){:host .hero{gap:40px}:host .hero .name{font-size:2vw!important}:host .hero .designation{font-size:3vw!important}}";


var $b9d6825b09dd5512$exports = {};
$b9d6825b09dd5512$exports = "<div class=hero>\n  <div class=text>\n    <div class=header>\n      <div class=name>Bhupender Kumar</div>\n      <div class=designation>Frontend Designer &amp; Creator</div>\n    </div>\n    <div class=description>\n      Crafting beautiful digital experiences with a passion for design and\n      attention to detail.\n    </div>\n  </div>\n\n  <div class=cta>\n    <div class=\"btn product\">Products</div>\n    <div class=\"btn contact\">Contact</div>\n  </div>\n</div>\n<div class=illustration></div>\n<div class=\"ellipse one\"></div>\n<div class=\"ellipse two\"></div>\n<div class=background></div>\n";



var $e7kxL = parcelRequire("e7kxL");
class $f897ae2b42cbdf8c$export$fb7d24a5e068181 extends HTMLElement {
    template = ()=>`
   <style>${$0f924eceae744768$exports}</style>
    ${0, (/*@__PURE__*/$parcel$interopDefault($b9d6825b09dd5512$exports))}
  `;
    ComponentElements;
    ComponentNames = {
        product: ".product",
        contact: ".contact"
    };
    constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
        this.render();
        this.ComponentElements = (0, $e7kxL.getRequiredComponentElements)(this, this.ComponentNames);
    }
    handleEvent(event) {
        const target = event.target;
        if (target.classList.contains("product")) (0, $e7kxL.navigateTo)("shop.html");
        else if (target.classList.contains("contact")) (0, $e7kxL.scrollToBottom)();
    }
    connectedCallback() {
        const product = this.ComponentElements.get(this.ComponentNames.product);
        const contact = this.ComponentElements.get(this.ComponentNames.contact);
        product?.addEventListener("click", this);
        contact?.addEventListener("click", this);
    }
    disconnectedCallback() {
        const product = this.ComponentElements.get(this.ComponentNames.product);
        const contact = this.ComponentElements.get(this.ComponentNames.contact);
        product?.removeEventListener("click", this);
        contact?.removeEventListener("click", this);
    }
    render() {
        if (this.shadowRoot) this.shadowRoot.innerHTML = this.template().trim();
    }
}
customElements.define("hero-custom", $f897ae2b42cbdf8c$export$fb7d24a5e068181);



var $e7kxL = parcelRequire("e7kxL");
(0, $e7kxL.isUnderMaintenace)();
const $b4e14b6b8da86996$var$webComponents = [
    (0, $ezJWQ.IconComponent),
    (0, $f897ae2b42cbdf8c$export$fb7d24a5e068181),
    (0, $47ce20f770578c92$export$2c92791fa4a99cea),
    (0, $bcb56616bf6c4d42$export$f5d4b1ce866dd389),
    (0, $e5CeE.ToastComponent)
];
$b4e14b6b8da86996$var$webComponents.forEach((item)=>item.toString());
(0, $e7kxL.setMetaData)("home_meta.json");


//# sourceMappingURL=public.ea575681.js.map
